
const crearAnamnesisLS = localStorage.getItem('crearAnamnesis')
  ? JSON.parse(localStorage.getItem('crearAnamnesis'))
  : {};

export default {
  state: {
    idAnamnesis : null,
    ...crearAnamnesisLS,
  },

  mutations: {

    resetAnamnesis(state) {
      state.idAnamnesis            = null;
      state.motivoConsulta         = null;
      state.ocurrencia             = null;
      state.esInterconsulta        = null;
      state.antecedentesPersonales = null;
      state.antecedentesFamiliares = null;
      state.semiologia             = { tipo:null, data:null };
      state.revisionOrganos        = null;
      state.examenFisico           = null;
      state.problemaActual         = null;
      state.diagnostico            = null;
      state.planTratamiento        = `1.- PLAN EDUCACIONAL: \n2.- PLAN DIAGNÓSTICO: \n3.- PLAN TERAPÉUTICO:`;
    },
    
    setIdAnamnesis( state, data ){
      state.idAnamnesis = data
    },
    setMotivoConsulta( state, data ){
      state.motivoConsulta = data
    },

    setOcurrencia( state, data ){
      state.ocurrencia = data
    },

    setEsInterconsulta(state, data) {
      state.esInterconsulta = data
    },

    setAntecedentesPersonales(state, data) {
      state.antecedentesPersonales = data;
    },

    setAntecedentesFamiliares(state, data) {
      state.antecedentesFamiliares = data;
    },


    setRevisionOrganos(state, data) {
      state.revisionOrganos = data;
    },

    setExamenFisico(state, data){
      state.examenFisico = data;
    },

    setDiagnostico(state, data){
      state.diagnostico = data
    },

    setProblemaActual(state, data){
      state.problemaActual = data
    },

    setPlanTratamiento(state, data){
      state.planTratamiento = data
    }

  },


};
